import { render, staticRenderFns } from "./AfterShare.vue?vue&type=template&id=08f556e6&"
import script from "./AfterShare.vue?vue&type=script&lang=js&"
export * from "./AfterShare.vue?vue&type=script&lang=js&"
import style0 from "./AfterShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports